import React, { Component } from "react";
import {
  Row,
  Col,
  Button,
  Tabs,
  Nav,
  Tab,
  Table,
  Modal,
  Image,
  Container,
  Card,
  Form
} from "react-bootstrap";
import { appConfig } from "../../config";

import ReactPaginate from "react-paginate";
var dateFormat = require("dateformat");

class CreateInvoice extends Component {
  constructor(props) {
    super(props);

    this.state = {
      fileImg: "",
      file: "",

      grandTotal: "",

      amntError:""
    };
  }

  changeInvoice = ev => {
    let name = ev.target.name;
    let val = ev.target.value;

    if (name === "invAmt") {
      this.setState({
        ...this.state,
        grandTotal: val,
        amntError:""
      });
    }
  };

  //Attaching doc
  uploadinvoiceDoc = e => {
    if(e.target.files[0]){
      this.setState({
        // file: URL.createObjectURL(e.target.files[0])
        fileImg: URL.createObjectURL(e.target.files[0]),
        file: e.target.files[0],
        fileError:""
      });
    }else{
      this.setState({
        file: "",
        fileError:""
      })
    }
  };

  //Validation function
  validate=(filename)=>{
    // console.log(filename);
    let isError = false;

    const regex= (/^[0-9]+$/);

     if(filename&&filename!==""){
      this.getExtension = filename => {
        return filename.name.split(".").pop();
      };
    } 

    let err = "Please enter the invoice amount";
    let err1 = "Please enter a valid amount";
    let err2 = "Please attach the invoice";
    let err3 = "Only `.jpg`, `.jpeg`, `.png`, `.pdf` files accepted";

    const errors ={
      amntError:"",
      fileError:""
    };

    if(this.state.grandTotal===""){
      isError=true;
      errors.amntError=err;
    }
    if(this.state.grandTotal !== "" && !regex.test(this.state.grandTotal)){
      isError=true;
      errors.amntError=err1;
    }
    if(this.state.file===""){
      isError=true;
      errors.fileError=err2;
    }

    if(filename&&filename!==""){
      const getExt = this.getExtension(filename);
      if((this.getExtension(filename) !== "pdf")&&(this.getExtension(filename) !== "jpg")&&(this.getExtension(filename) !== "jpeg")&&(this.getExtension(filename) !== "png")){
        isError=true;
        errors.fileError=err3;
      }
    }

    this.setState({
      ...this.state,
      ...errors
    });

    return isError;
  }

  //Creating invoice
  createInvoice = () => {
    const { InvoiceDetails, completeitemDetails } = this.props;
    const details =
      InvoiceDetails && InvoiceDetails.item
        ? InvoiceDetails && InvoiceDetails.item
        : null;

    const body = {
      orgId: details && details.orderFrom && details.orderFrom.orgId,
      customerId: details && details.orderTo && details.orderTo.id,
      vendorId: details && details.orderFrom && details.orderFrom.id,
      orderId:
        details &&
        details.orderDetail &&
        details.orderDetail.orderId &&
        details.orderDetail.orderId.id,
      orderNo: details && details.orderNo,
      //amount:completeitemDetails&&completeitemDetails.reduce((totalAmount, val) => totalAmount + (val.qntty * val.unitPrice), 0),
      amount: this.state.grandTotal,
      file: this.state.file
    };

    const validinvoice = this.validate(this.state.file);

    if(!validinvoice){
      this.props.manualInvoice(body);
      this.setState({
        fileImg: "",
        file: "",
        grandTotal: "",
        amntError:"",
        fileError:""
      },()=>{this.props.close();});
    }
  };

  closeModal=()=>{
    this.setState({
      fileImg: "",
      file: "",
      grandTotal: "",
      amntError:"",
      fileError:""
    },()=>{this.props.close();});
  }

  render() {
    const {
      show,
      close,
      InvoiceDetails,
      completeitemDetails,
      completeitemDetailsCount
    } = this.props;
    const { createInvoice, uploadinvoiceDoc, changeInvoice,closeModal } = this;
    const { grandTotal } = this.state;

    const details =
      InvoiceDetails && InvoiceDetails.item
        ? InvoiceDetails && InvoiceDetails.item
        : null;

    //const grandTotal = completeitemDetails&&completeitemDetails.reduce((totalAmount, val) => totalAmount + (val.qntty * val.unitPrice), 0);
    //console.log(grandTotal);//For calculating the total amount

    return (
      <div>
        <div className="modelboxdesigns">
          <Modal
            show={show}
            onHide={closeModal}
            animation={false}
            backdrop="static"
            className="Modalmodelboxdesigns"
          >
            <Modal.Header
              style={{
                fontSize: "35px",
                backgroundColor: "#1768B7",
                color: "white"
              }}
              closeButton
            >
              <Modal.Title>
                <span style={{ fontSize: "20px" }}>Upload Invoice</span>
              </Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <Form>
                <Form.Group as={Row} controlId="chemName">
                  <Form.Label column sm="4">
                    Chemist Name 
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      plaintext
                      readOnly
                      value={
                        details && details.orderFrom && details.orderFrom.name
                      }
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="orgName">
                  <Form.Label column sm="4">
                    Organization Name 
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      plaintext
                      readOnly
                      value={details && details.orderFromName}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="orderNo">
                  <Form.Label column sm="4">
                    Order No 
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      plaintext
                      readOnly
                      value={details && details.orderNo}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="payType">
                  <Form.Label column sm="4">
                    Payment Mode 
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      className="cmn_Cap"
                      plaintext
                      readOnly
                      value={details && details.payMode}
                    />
                  </Col>
                </Form.Group>

                <Form.Group as={Row} controlId="payAmnt">
                  <Form.Label column sm="4">
                    Invoice Amount 
                  </Form.Label>
                  <Col sm="8">
                    {/* <Form.Control plaintext readOnly value={grandTotal} />*/}
                    <Form.Control
                      type="text"
                      // placeholder="Invoice Amount"
                      name="invAmt"
                      value={grandTotal}
                      onChange={changeInvoice}
                      autoComplete="off"
                    />
                    <div className="errStyle" style={{ float: "left" }}>
                      {this.state.amntError}
                    </div>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="invoiceimg">
                  <Form.Label column sm="4">
                    Upload Invoice 
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      type="file"
                      onChange={uploadinvoiceDoc}
                      accept=".png, .jpg, .jpeg, .pdf"
                    />
                    <div className="errStyle" style={{ float: "left" }}>
                      {this.state.fileError}
                    </div>
                  </Col>
                </Form.Group>
              </Form>
            </Modal.Body>
            <Modal.Footer style={{ backgroundColor: "#1768B7" }}>
              <Button className="queryBtn" onClick={createInvoice}>
              Upload Invoice
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    );
  }
}

export default CreateInvoice;
